var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{staticClass:"w-100",attrs:{"id":"content"}})])
}]

export { render, staticRenderFns }